export function useTrackingWatchdog(_orgId: string | null): void {}
